import axios from 'axios';

const runtimeApiUrl = window.__APP_CONFIG__?.API_URL;
const envApiUrl = process.env.REACT_APP_API_URL;
const BASE_URL = (runtimeApiUrl || envApiUrl || 'https://rahvan.onrender.com').replace(/\/+$/, '');

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false

});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('Istek hatasi:', error);
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('Cevap hatasi:', error.response || error);
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
